import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import * as types from "../shared/types";
import useTaskDetailsFormControlStore from "../stores/TaskDetailsFormControlStore";
import useInvoiceItemTypeStore from "../stores/InvoiceItemTypeStore";

const OtherItemForm = (props) => {
  const [propState, setPropState] = useState(props);
  const { invoiceItemTypes } = useInvoiceItemTypeStore();
  const descRef = useRef();
  const priceRef = useRef();
  const noteRef = useRef();
  const propStateListActTaskItem = useRef(
    props.otherWorkList[`${props.actTask}`].wmlist[props.item],
  );
  const isMountedComponent = useRef(true);

  const { isButtonDisabled } = useTaskDetailsFormControlStore((state) => ({
    isButtonDisabled: state.isButtonDisabled,
  }));

  useEffect(() => {
    if (isMountedComponent.current) {
      setPropState(props);
      propStateListActTaskItem.current =
        props.otherWorkList[`${props.actTask}`].wmlist[props.item];
    }
    return () => {
      isMountedComponent.current = false;
    };
  }, [props]);

  const onInputChange = async (event) => {
    if (event) event.preventDefault();

    if (priceRef.current.value == types.INVOICE_ITEM_EXTREM_PRICE) {
      toast.warning("Ez az érték itt nem megengedett");
      return;
    }

    let tempInvItem = Object.assign({}, propState.otherWorkList);
    let tmpInvWmListItem =
      tempInvItem[`${propState.actTask}`].wmlist[propState.item];

    tmpInvWmListItem.description = descRef.current.value;
    tmpInvWmListItem.price = priceRef.current.value;
    tmpInvWmListItem.note = noteRef.current.value;

    propState.SetOtherWorkList(tempInvItem);
  };

  // Handle dropdown changes. We read the selected type and update the form fields accordingly
  const onTypeSelectChange = (e) => {
    const selectedId = e.target.value;
    const selectedType = invoiceItemTypes.find(
      (t) => t.id.toString() === selectedId,
    );

    if (selectedType) {
      // Manually update the DOM values via refs
      descRef.current.value = selectedType.name;
      priceRef.current.value = selectedType.price;

      // Trigger the sync to the parent state immediately
      onInputChange();
    }
  };

  return (
    <Form key={propState.keyProp + "otherform"} className="focus_selector">
      <Form.Group controlId="ctype" className="mb-3">
        <Form.Label>
          <small style={{ color: "indigo", textAlign: "left" }}>
            Sablon kiválasztása:
          </small>
        </Form.Label>
        <Form.Control
          as="select"
          disabled={isButtonDisabled}
          onChange={onTypeSelectChange}
          defaultValue=""
        >
          <option value="" disabled>
            -- Válasszon egy sablont --
          </option>
          {invoiceItemTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name} ({type.price} Ft)
            </option>
          ))}
        </Form.Control>
      </Form.Group>
      <hr />

      <Form.Group controlId="cdesc">
        <Form.Label
          key={propState.keyProp + "focus"}
          ref={(focref) => {
            if (!!focref)
              propState.focusRefList.current[propState.keyProp + "focus"] =
                focref;
          }}
        >
          <small style={{ color: "indigo", textAlign: "left" }}>
            Tétel leírása:
          </small>
        </Form.Label>
        <Form.Control
          disabled={isButtonDisabled}
          placeholder="Tétel leírása"
          onBlur={onInputChange}
          defaultValue={propStateListActTaskItem.current.description}
          name="desc"
          ref={descRef}
        />
      </Form.Group>

      <Form.Group controlId="cprice">
        <Form.Label>
          <small style={{ color: "indigo", textAlign: "left" }}>Ár:</small>
        </Form.Label>
        <Form.Control
          disabled={isButtonDisabled}
          type="number"
          placeholder="Ár"
          onBlur={onInputChange}
          defaultValue={propStateListActTaskItem.current.price}
          name="price"
          ref={priceRef}
        />
      </Form.Group>

      <Form.Group controlId="cnote">
        <Form.Label>
          <small style={{ color: "indigo", textAlign: "left" }}>
            Szerelő megjegyzése az ügyfél felé:
          </small>
        </Form.Label>
        <Form.Control
          disabled={isButtonDisabled}
          as="textarea"
          rows="3"
          placeholder="Megjegyzés"
          onBlur={onInputChange}
          defaultValue={propStateListActTaskItem.current.note}
          name="note"
          ref={noteRef}
        />
      </Form.Group>
    </Form>
  );
};;

export default OtherItemForm;
